import { useState } from 'react';
import { IFeaturesConfig, IFeature } from '../../../../../interface/interfaces';

const useUniqueTools = () => {
    const [seenTools, setSeenTools] = useState<Set<string>>(new Set<string>());

    const uniqueTools = (feature: IFeaturesConfig) => {
        return feature?.Features?.filter((featureItem: IFeature) => {
            if (seenTools.has(featureItem.Tool)) {
                return false;
            } else {
                seenTools.add(featureItem.Tool);
                return true;
            }
        });
    };

    return { uniqueTools, setSeenTools };
};

export default useUniqueTools;
